import Box from '@mui/material/Box';
import { Form } from 'react-admin';
import TextInputWithLabels from '@/components/common/forms/common/text-input-with-labels/text-input-with-labels';
import ImageInputWithLabelOnTop from '@/components/common/forms/common/image-input-with-label-on-top/image-input-with-label-on-top';

const formId = '_form_maintenance_curative_autre_1';

interface Props {
    isLoading: boolean;
    onCancel: any;
    onSubmit: any;
    readOnly?: boolean;
    defaultValues?: (formId: string) => {};
}

const OthersForm = ({ readOnly = false, defaultValues = (_formId: string): any => {} }: Props) => (
    <Form defaultValues={defaultValues(formId)}>
        <Box
            sx={{
                display: 'grid',
                gap: 2,
            }}
        >
            <TextInputWithLabels topLabel={'Description du besoin:'} source='AutreTxt' multiline readOnly={readOnly} />

            <TextInputWithLabels
                topLabel={'Nombre ou unités'}
                rightLabel={'U'}
                source='Nombre_ou_unites'
                readOnly={readOnly}
            />

            <ImageInputWithLabelOnTop label='Joindre des photos (.png, .jpg)' source='media' readOnly={readOnly} />

            <TextInputWithLabels topLabel={'Précision sur la localisation'} source='Localisation' readOnly={readOnly} />
        </Box>
    </Form>
);

export default OthersForm;
